
import { v4 as uuidv4 } from 'uuid'

export const initialAddTitles = async (newId, data = null) => {

    const lastCorr = 0;
    return {
        correlativo: lastCorr,
        id: newId,
        index: newId,
        creado: false,
        nombre: data?.nombre || '',
        cant: data?.cant || 1,
        dias: data?.dias || 1,
        precio_unitario: data?.precio_unitario || 0,
        pre_subtotal_precio: data?.pre_subtotal_precio || 0,
        descuento: data?.descuento || 0,
        precio_subtotal: data?.precio_subtotal || 0,
        costo_unitario: data?.costo_unitario || 0,
        costo_subtotal: data?.costo_subtotal || 0,
        margen_monto: data?.margen_monto || 0,
        margen_porcentaje: data?.margen_porcentaje || 0,
        tipo: 'title',
        codigo: '',
        id_servicio: data?.id_servicio || 0,
        id_categoria: data?.id_categoria || 0,
        abierto: data?.abierto || false,
        id_titulo: 0,
        sorting: null,
        selected: false,
        items: [],
        id_tipo_doc: data?.id_tipo_doc
    }
}

export const initialAddItems = async (params) => {

    const {
        newId,
        idTitle,
        sorting,
        data,
        categoryId
    } = params

    const lastCorr = 0;
    return {
        correlativo: lastCorr,
        id: newId,
        index: newId,
        creado: false,
        nombre: data?.nombre || '',
        descripcion_larga: data?.descripcion_larga || '',
        cant: data?.cant || 1,
        dias: data?.dias || 1,
        precio_unitario: data?.precio_unitario || 0,
        pre_subtotal_precio: data?.pre_subtotal_precio || 0,
        descuento: data?.descuento || 0,
        precio_subtotal: data?.precio_subtotal || 0,
        costo_unitario: data?.costo_unitario || 0,
        costo_subtotal: data?.costo_subtotal || 0,
        margen_monto: data?.margen_monto || 0,
        margen_porcentaje: data?.margen_porcentaje || 0,
        tipo: 'item',
        codigo: data?.codigo || '',
        id_servicio: data?.id_servicio || 0,
        id_categoria: data?.id_categoria || (categoryId ? categoryId : 0),
        abierto: data?.abierto || false,
        id_titulo: idTitle,
        sorting,
        selected: false,
        unidad_medida: data?.unidad_medida || 'UN',
        fecha_inicio: null,
        fecha_fin: null,
        items: [],

        id_tipo_doc: data?.id_tipo_doc,
        porcentaje_impuesto: data?.porcentaje_impuesto || 0,
        total_impuesto: data?.total_impuesto || 0,
        total_a_pagar: data?.total_a_pagar || 0
    }
}

export const initialDuplicateItems = (item, newId) => {
    return {
        correlativo: 0,
        id: newId,
        index: newId,
        creado: false,
        nombre: item.nombre,
        descripcion_larga: item.descripcion_larga,
        cant: item.cant,
        dias: item.dias,
        precio_unitario: item.precio_unitario,
        pre_subtotal_precio: item?.pre_subtotal_precio || 0,
        descuento: item?.descuento || 0,
        precio_subtotal: item.precio_subtotal,
        costo_unitario: item.costo_unitario,
        costo_subtotal: item.costo_subtotal,
        margen_monto: item.margen_monto,
        margen_porcentaje: item.margen_porcentaje,
        tipo: item.tipo,
        codigo: item.codigo,
        id_servicio: item.id_servicio,
        id_categoria: item.id_categoria,
        abierto: item.abierto,
        id_titulo: item.id_titulo,
        sorting: item.sorting,
        selected: false,
        unidad_medida: item.unidad_medida || 'UN',
        items: item.items,

        id_tipo_doc: item.id_tipo_doc,
        porcentaje_impuesto: item?.porcentaje_impuesto || 0,
        total_impuesto: item?.total_impuesto || 0,
        total_a_pagar: item?.total_a_pagar || 0

    }
}

export const initialCalculoTotales = async (detail, Newitems, margen_sobre_costo = null) => {

    let totalVenta = 0;
    let totalCostos = 0;
    for (let i = 0; i < Newitems.length; i++) {
        const el = Newitems[i];
        if (Newitems[i].tipo === 'title') {
            const itemsByTitle = el.items;
            for (let x = 0; x < itemsByTitle.length; x++) {
                const element = itemsByTitle[x];
                totalVenta += element.precio_subtotal;
                totalCostos += element.costo_subtotal;
            }
        }
    }

    const subtotal = totalVenta;
    const totalCostosDirectos = totalCostos;

    const descuento = detail.descuento;
    const totalDescontado = subtotal - descuento;

    const totalSobrecargoGG = (detail?.sobrecargo_gg || 0)
    const totalSobrecargoUtilidad = (detail?.sobrecargo_utilidad || 0)

    const totalVentaNeta = totalDescontado + totalSobrecargoGG + totalSobrecargoUtilidad
    const totalCostosNeto = totalCostosDirectos + totalSobrecargoGG
    const totalRentabilidadNeta = totalVentaNeta - totalCostosNeto

    const newMargenGastoP = parseFloat(((totalCostosNeto / totalVentaNeta) * 100).toFixed(2))
    // const newMargenGastoP = parseFloat(((totalCostosNeto / totalDescontado) * 100).toFixed(2))

    let margenRentabilidadNeta = (totalRentabilidadNeta / totalVentaNeta) * 100;
    if (margen_sobre_costo) {
        margenRentabilidadNeta = (totalRentabilidadNeta / totalCostosNeto) * 100;
    }

    const totalImpuesto = totalVentaNeta * 0.18;
    const newTotal = totalVentaNeta + totalImpuesto;

    const newTotales = {
        sub_total: subtotal,
        descuento: descuento,
        total_cliente: totalVentaNeta,
        total_gasto_p: totalCostosNeto,
        total_utilidad_p: totalRentabilidadNeta,
        margen_gasto_p: newMargenGastoP,
        margen_utilidad_p: margenRentabilidadNeta,
        total_costos_directos: totalCostosDirectos,
        total_utilidad_r: 0,
        margen_utilidad_r: 0,
        total: newTotal
    }

    return newTotales;
}

export const initialCalItemByLine = (from, data) => {
    const { cant = 1, dias = 1, precio_unitario = 0, descuento = 0, costo_unitario = 0 } = data

    const preSubTotalPrecio = parseFloat(cant) * parseFloat(dias) * parseFloat(precio_unitario)
    const subTotalPrecio = preSubTotalPrecio - parseFloat(descuento)
    const subTotalCosto = parseFloat(cant) * parseFloat(dias) * parseFloat(costo_unitario)

    let totalRentabilidad = subTotalPrecio - subTotalCosto
    // if (totalRentabilidad < 0) {
    //     totalRentabilidad = 0
    // }

    let margenRentabilidad = (totalRentabilidad / subTotalPrecio) * 100
    // console.log({ margenRentabilidad })

    if (margenRentabilidad === '- Infinity' || margenRentabilidad === -Infinity) {
        margenRentabilidad = 0
    } else {
        margenRentabilidad = margenRentabilidad ? parseFloat(margenRentabilidad.toFixed(2)) : 0
    }

    return {
        pre_subtotal_precio: parseFloat(parseFloat(preSubTotalPrecio).toFixed(2)),
        precio_subtotal: parseFloat(parseFloat(subTotalPrecio).toFixed(2)),
        costo_subtotal: parseFloat(parseFloat(subTotalCosto).toFixed(2)),
        margen_monto: parseFloat(parseFloat(totalRentabilidad).toFixed(2)),
        margen_porcentaje: margenRentabilidad
    }
}

// items pptos gastos
export const initialAddTitlesPptosGastos = async (newId) => {
    return {
        id: newId,
        index: newId,
        creado: false,
        nombre: '',
        cant: 0,
        dias: 0,
        costo_unitario: 0,
        costo_subtotal: 0,
        total_gasto_real: 0,
        porcentaje_gasto_real: 0,
        total_por_gastar: 0,
        porcentaje_por_gastar: 0,
        tipo: 'title',
        cerrado_compras: '',
        id_servicio: 0,
        id_categoria: 0,
        id_titulo: 0,
        selected: false,
        items: [],
        id_tipo_doc: null
    }
}

export const initialAddItemsPptosGastos = async (newId, idTitulo) => {
    return {
        id: newId,
        index: newId,
        creado: false,
        nombre: '',
        cant: 1,
        dias: 1,
        costo_unitario: 0,
        costo_subtotal: 0,
        total_gasto_real: 0,
        porcentaje_gasto_real: 0,
        total_por_gastar: 0,
        porcentaje_por_gastar: 0,
        tipo: 'item',
        cerrado_compras: '',
        id_servicio: 0,
        id_categoria: 0,
        id_titulo: idTitulo,
        selected: false,
        id_tipo_doc: null
    }
}

export const initialCalculoTotalesPptosGastos = async (detail, Newitems) => {

    let sumaSubtotal = 0;
    for (let i = 0; i < Newitems.length; i++) {
        const el = Newitems[i];
        if (Newitems[i].tipo === 'title') {
            const itemsByTitle = el.items;
            for (let x = 0; x < itemsByTitle.length; x++) {
                const element = itemsByTitle[x];
                sumaSubtotal += element.subtotal;
            }
        }
    }

    const newTotales = {
        total: sumaSubtotal,
    }

    return newTotales;
}

// initial items

const getCatSelected = (items, catalogGroup) => {
    let catSelected = []

    for (let x = 0; x < items.length; x++) {
        const foundTitleId = catSelected.find(it => it.id === items[x].id_categoria)
        if (!foundTitleId) {
            const title = catalogGroup.find(t => t.id === items[x].id_categoria)
            catSelected = [
                ...catSelected,
                {
                    id: title.id,
                    name: title.nombre
                }
            ]
        }
    }

    return catSelected

}

export const sortInitialItem = async (selectedItems, catalogGroup) => {
    const catSelected = getCatSelected(selectedItems, catalogGroup)

    let orderedItems = []
    for (let i = 0; i < catSelected.length; i++) {
        const currentCat = catSelected[i]

        const newIdTitle = uuidv4()
        let newTitle = await initialAddTitles(newIdTitle)

        newTitle = {
            ...newTitle,
            id_categoria: currentCat.id,
            nombre: currentCat.name
        }

        // sorting items by title
        let sortingByTitle = null
        for (let x = 0; x < selectedItems.length; x++) {
            const it = selectedItems[x]
            console.log('--it--', it)

            if (it.id_categoria === currentCat.id) {
                sortingByTitle = sortingByTitle ? (sortingByTitle + 1) : 0

                const newId = uuidv4()
                let item = await initialAddItems(newId, newIdTitle, sortingByTitle)

                item = {
                    ...item,
                    nombre: it.nombre,
                    id_servicio: it.id,
                    id_categoria: it.id_categoria
                }

                newTitle = {
                    ...newTitle,
                    items: [...newTitle.items, item]
                }

            }

        }

        // add item by title
        orderedItems = [...orderedItems, newTitle]

    }

    console.log('--orderedItems--', orderedItems)

    return orderedItems

}

export const sortInitialItemPptosGastos = async (selectedItems, catalogGroup) => {
    const catSelected = getCatSelected(selectedItems, catalogGroup)

    let orderedItems = []
    for (let i = 0; i < catSelected.length; i++) {
        const currentCat = catSelected[i]

        const newIdTitle = uuidv4()
        let newTitle = await initialAddTitlesPptosGastos(newIdTitle)

        newTitle = {
            ...newTitle,
            id_categoria: currentCat.id,
            nombre: currentCat.name
        }

        // sorting items by title
        let sortingByTitle = null
        for (let x = 0; x < selectedItems.length; x++) {
            const it = selectedItems[x]
            console.log('--it--', it)

            if (it.id_categoria === currentCat.id) {
                sortingByTitle = sortingByTitle ? (sortingByTitle + 1) : 0

                const newId = uuidv4()
                let item = await initialAddItemsPptosGastos(newId, newIdTitle, sortingByTitle)

                item = {
                    ...item,
                    nombre: it.nombre,
                    id_servicio: it.id,
                    id_categoria: it.id_categoria
                }

                newTitle = {
                    ...newTitle,
                    items: [...newTitle.items, item]
                }

            }

        }

        // add item by title
        orderedItems = [...orderedItems, newTitle]

    }

    console.log('--orderedItems--', orderedItems)

    return orderedItems

}